import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/Money/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Money',
  field: 'Measurement',
  weeks: [9, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () => import(/* webpackChunkName: "Year1/Summer/Money/1Unitising" */ './1Unitising')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Money/2RecogniseCoins" */ './2RecogniseCoins')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Money/3RecogniseNotes" */ './3RecogniseNotes')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Money/4CountInCoins" */ './4CountInCoins')
    })
  ]
});
export default Block;
